var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#020A1C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#23AF91",
    d: "m12.91 15.992 5.223 5.224 3.297-3.297a1.49 1.49 0 0 1 2.106 2.106l-4.35 4.351a1.502 1.502 0 0 1-2.107 0l-6.276-6.278v3.732a1.49 1.49 0 0 1-2.983 0V10.15a1.492 1.492 0 0 1 2.982-.001v3.732l6.277-6.277a1.501 1.501 0 0 1 2.106 0l4.354 4.35a1.493 1.493 0 0 1-2.106 2.107l-3.297-3.297-5.226 5.228Zm5.226-1.493a1.493 1.493 0 1 0-.002 2.988 1.493 1.493 0 0 0 .002-2.989v.001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuCoin);
export default __webpack_public_path__ + "static/media/KuCoin.ee1951198d405f4ef58f636c6736ee17.svg";
export { ForwardRef as ReactComponent };